import styled from 'styled-components';

const Subtitle = styled.span`
  margin: 0px;
  font-size: ${p => (p.size === 'small' ? '10px' : '13px')};
  line-height: 1;
  font-weight: 400;
  color: ${p => (p.style.color ? p.style.color : '#000')};
  display: ${p => (p.style.display ? p.style.display : 'inline')};
`;

Subtitle.defaultProps = {
  style: {},
  size: null,
};

export default Subtitle;



// WEBPACK FOOTER //
// ./src/components/text/Subtitle/index.js